define("shared/components/shared/linkinbio/shopify-product-details", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@glimmer/tracking", "@ember/array", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _tracking, _array, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@glimmer/tracking",0,"@ember/array",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section
    class="o--modalBody--secondary has--footer"
    {{perfect-scroll}}
    {{did-insert this.resetSelectedCategories}}
  >
    <p data-test-id="shopify-product-title">
      <span class="u--text--bold">
        {{t "shopify.modal_product.product"}}
      </span>
      <Shared::Ui::Button
        @class="u--inline u--float--right u--text--uppercase u--text--sm u--text--hl"
        @text={{t "shared_phrases.choose_different_product"}}
        @type="unstyled"
        @onClick={{this.clearParentProductChoice}}
      />
    </p>
    {{#if @product}}
      <div class="o--card" {{on "click" this.clearParentProductChoice}}>
        <div class="o--list__item--img u--p__tb__xs">
          <div class="o--list__image">
            <figure class="o--mediaContainer">
              {{#each @product.images as |image|}}
                <img src={{image.src}} class="o--media">
                <b class="o--mediaOverlay"></b>
              {{/each}}
            </figure>
          </div>
          <h4 class="o--list__title u--p__r__0 u--ellipsis">
            {{@product.title}}
          </h4>
          <p class="o--list__text u--ellipsis">
            {{html-safe this.priceString}}
          </p>
        </div>
      </div>
      {{! Product Variant Dropdown }}
      {{!  Variants Label }}
      <div class="u--block  u--m__t__md u--clearfix">
        <p class="u--inline u--float--left u--text--bold u--m__b__xs">
          {{t "shopify.modal_product.select_variants"}}
        </p>
        {{#if this.showResetButton}}
          <Shared::Ui::Button
            @class="u--float--right u--text--sm u--text--hl"
            @text={{t "shopify.modal_product.reset_variants"}}
            @type="unstyled"
            @onClick={{this.clearSelectedCategories}}
          />
        {{/if}}
        <p class="u--block u--float--left">
          {{t "shopify.modal_product.select_variants_description"}}
        </p>
      </div>
      <div class="u--block">
        {{#each this.categories as |category|}}
          <Shared::Linkinbio::ShopifyCategorySelect
            @category={{category}}
            @updateSelected={{this.updateSelected}}
          />
        {{/each}}
      </div>
    {{else if @link.typeError}}
      <div class="o--card" {{on "click" this.clearParentProductChoice}}>
        <div class="o--list__item--img u--p__tb__xs">
          <div class="o--list__image">
            <figure class="o--mediaContainer">
              <b class="o--mediaOverlay"></b>
              <img class="o--media" src={{@link.shopifyProductImage}}>
            </figure>
          </div>
          <div class="o--list__text cML--list__text">
            {{svg-jar "warning" class="o--icon u--m__r__sm"}}
            <p class="u--m__b__0">
              {{t "shopify.product.no_product"}}
            </p>
          </div>
        </div>
      </div>
      <p class="cML--list__message">
        {{t "shopify.product.contact_shopify"}}
      </p>
    {{/if}}
  </section>
  */
  {
    "id": "Yo0gV4fU",
    "block": "[[[11,\"section\"],[24,0,\"o--modalBody--secondary has--footer\"],[4,[38,0],null,null],[4,[38,1],[[30,0,[\"resetSelectedCategories\"]]],null],[12],[1,\"\\n  \"],[10,2],[14,\"data-test-id\",\"shopify-product-title\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"shopify.modal_product.product\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,3],null,[[\"@class\",\"@text\",\"@type\",\"@onClick\"],[\"u--inline u--float--right u--text--uppercase u--text--sm u--text--hl\",[28,[37,2],[\"shared_phrases.choose_different_product\"],null],\"unstyled\",[30,0,[\"clearParentProductChoice\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[11,0],[24,0,\"o--card\"],[4,[38,5],[\"click\",[30,0,[\"clearParentProductChoice\"]]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--list__item--img u--p__tb__xs\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--list__image\"],[12],[1,\"\\n          \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,1,[\"images\"]]],null]],null],null,[[[1,\"              \"],[10,\"img\"],[15,\"src\",[30,2,[\"src\"]]],[14,0,\"o--media\"],[12],[13],[1,\"\\n              \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n\"]],[2]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"h4\"],[14,0,\"o--list__title u--p__r__0 u--ellipsis\"],[12],[1,\"\\n          \"],[1,[30,1,[\"title\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--list__text u--ellipsis\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[[30,0,[\"priceString\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"u--block  u--m__t__md u--clearfix\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--inline u--float--left u--text--bold u--m__b__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"shopify.modal_product.select_variants\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"showResetButton\"]],[[[1,\"        \"],[8,[39,3],null,[[\"@class\",\"@text\",\"@type\",\"@onClick\"],[\"u--float--right u--text--sm u--text--hl\",[28,[37,2],[\"shopify.modal_product.reset_variants\"],null],\"unstyled\",[30,0,[\"clearSelectedCategories\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,2],[14,0,\"u--block u--float--left\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"shopify.modal_product.select_variants_description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"categories\"]]],null]],null],null,[[[1,\"        \"],[8,[39,9],null,[[\"@category\",\"@updateSelected\"],[[30,3],[30,0,[\"updateSelected\"]]]],null],[1,\"\\n\"]],[3]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,4,[\"typeError\"]],[[[1,\"    \"],[11,0],[24,0,\"o--card\"],[4,[38,5],[\"click\",[30,0,[\"clearParentProductChoice\"]]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--list__item--img u--p__tb__xs\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--list__image\"],[12],[1,\"\\n          \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n            \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,4,[\"shopifyProductImage\"]]],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--list__text cML--list__text\"],[12],[1,\"\\n          \"],[1,[28,[35,10],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__sm\"]]]],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"shopify.product.no_product\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"cML--list__message\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"shopify.product.contact_shopify\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]],[13]],[\"@product\",\"image\",\"category\",\"@link\"],false,[\"perfect-scroll\",\"did-insert\",\"t\",\"shared/ui/button\",\"if\",\"on\",\"each\",\"-track-array\",\"html-safe\",\"shared/linkinbio/shopify-category-select\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/linkinbio/shopify-product-details.hbs",
    "isStrictMode": false
  });

  const DEFAULT_VARIANT_TITLE = 'Default Title';
  let ShopifyProductDetailsComponent = (_class = class ShopifyProductDetailsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "shopify", _descriptor, this);

      _initializerDefineProperty(this, "selectedCategories", _descriptor2, this);
    }

    get priceString() {
      return this.shopify.getProductPriceString(this.args.product);
    }

    get showResetButton() {
      const categories = this.categories || [];
      const {
        variants
      } = this.args.product;
      return categories.some(category => category.selectedOption) && variants.length !== 1;
    }

    get validVariants() {
      const selectedCategories = this.selectedCategories || [];
      const {
        variants
      } = this.args.product || [];
      return variants.filter(variant => selectedCategories.every(category => variant.selectedOptions.some(option => option.name === category.name && option.value === category.option)));
    }

    get categories() {
      const selectedCategories = this.selectedCategories || [];
      const categories = this.validVariants.reduce((categories, variant) => {
        variant.selectedOptions.forEach(option => {
          let category = categories.find(category => category.name === option.name);

          if (!category) {
            const defaultCategory = {
              name: option.name,
              options: []
            };
            categories.push(defaultCategory);
            category = defaultCategory;
          }

          const categoryContainsOption = category.options.some(categoryOption => categoryOption === option.value);

          if (!categoryContainsOption) {
            category.options.push(option.value);
          }
        });
        return categories;
      }, []).map(category => {
        const selectedCategory = selectedCategories.find(selectedCategory => selectedCategory.name === category.name);

        if (selectedCategory) {
          category.selectedOption = selectedCategory.option;
          category.hasVariant = true;
          category.isSelected = true;
        } else if (category.options.length === 1) {
          category.selectedOption = category.options[0];
          category.hasVariant = category.options[0] !== DEFAULT_VARIANT_TITLE;
          category.isSelected = true;
        } else {
          category.hasVariant = true;
          category.isSelected = false;
        }

        category.classSelector = this._getCategoryClassName(category.name);
        return category;
      });
      return categories;
    }

    clearParentProductChoice() {
      this.args.clearProductChoice();
    }

    updateSelected(selectedOption) {
      const category = this.categories.find(category => category.options.find(option => option === selectedOption));
      const option = category.options.find(option => option === selectedOption);
      const idx = this.selectedCategories.findIndex(selectedCategory => selectedCategory.name === option.name);
      const obj = {
        name: category.name,
        option
      };

      if (idx !== -1) {
        this.selectedCategories.replace(idx, 1, [obj]);
      } else {
        this.selectedCategories.pushObject(obj);
      }

      this.args.updateSelectedCategories(this.selectedCategories);
    }

    resetSelectedCategories() {
      const linkOptions = this.args.link.shopifyProductOptions || [];
      this.selectedCategories = [...linkOptions];
      this.args.updateSelectedCategories(this.selectedCategories);
    }

    clearSelectedCategories() {
      this.selectedCategories = [];
      this.args.clearSelectedCategories();
    }
    /**
     * Returns the category name as an identifier to be used for select elements.
     * Removes any invalid characters except letters, numbers, dashes and underscores.
     *
     * @method _getCategoryClassName
     * @param {String} categoryName
     *
     * @returns {String} An identifier beginning with `eLB--product__variants-` and ending with the category name
     * @protected
     */


    _getCategoryClassName(categoryName) {
      const formattedCategoryName = categoryName.replace(/[^_a-zA-Z0-9-\s]/g, '').replace(/\s/g, '-');
      return "eLB--product__variants-".concat(formattedCategoryName);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "shopify", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedCategories", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _applyDecoratedDescriptor(_class.prototype, "clearParentProductChoice", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearParentProductChoice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSelected", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetSelectedCategories", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetSelectedCategories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedCategories", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedCategories"), _class.prototype)), _class);
  _exports.default = ShopifyProductDetailsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ShopifyProductDetailsComponent);
});